export default {
  Hills: { id: 'H', name: 'Hills' },
  Woods: { id: 'W', name: 'Woods' },
  Marsh: { id: 'M', name: 'Marsh' },
  Habitation: { id: 'B', name: 'Habitation' },
  RiverCrossing: { id: 'RC', name: 'River Crossing' },
  River: { id: 'R', name: 'River' }
};
